import { useCallback } from 'react'

import { useAPDetailGender } from '../_components/ap-detail'

/**
 * Hook for handling gender selection with automatic scroll to program details.
 * Combines gender selection and scroll navigation into a single handler.
 *
 * @param scrollToId - ID of the element to scroll to after gender selection (default: 'detail-programu')
 * @returns Function to handle gender selection button clicks
 *
 * @example
 * ```typescript
 * const handleGenderClick = useAPDetailGenderSelection()
 *
 * <button onClick={() => handleGenderClick('female')}>
 *   Program pre ženu
 * </button>
 * ```
 */
export const useAPDetailGenderSelection = (scrollToId: string = 'detail-programu') => {
	const { setGender, handleScrollTo } = useAPDetailGender()

	return useCallback(
		(gender: 'male' | 'female'): void => {
			setGender(gender)
			handleScrollTo(scrollToId)
		},
		[setGender, handleScrollTo, scrollToId]
	)
}
